import React from 'react';
import {SubmitHandler, useForm} from "react-hook-form";
import {baseUrl} from "../../../../../constants/constants";
import {errorToast, successToast} from "../../../../../shared/toastify";
import {ITags} from "../../../../public/NewsPage/news";

interface ICurrentTag{
    tag: ITags,
    close:() => void
}
interface ICreateTag {
    name: string
}

const UpdateTag = ({tag, close}:ICurrentTag) => {
    const{
        register,
        handleSubmit,
        formState:{errors},
        setError
    } = useForm<ICreateTag>()

    const submit: SubmitHandler<ICreateTag> = async (data: any)=>{
        try{
            const res = await fetch(`${baseUrl}tags/${tag.id}`,{
                method: "PUT",
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(data)
            });
            if (res.status === 200) {
                successToast('Тег обновлён. Обновите страницу');
                close()
            } else if (res.status === 401) {
                setError('root', {type: 'custom', message: ''})
                errorToast('Ошибка 401')
            }
        } catch (err) {
            console.log(err)
        }
    }

    return (
        <form
            className={'regForm'}
            onSubmit={handleSubmit(submit)}
        >
            <input
                type="text"
                className="regInput"
                placeholder={'Название тега'}
                defaultValue={tag.name}
                {...register('name', {required: true})}
            />
            {errors.name && <p className={'wrong-message'}>Это поле обязательно</p>}

            <button className={'button form-btn'}>Обновить</button>
        </form>
    );
};

export default UpdateTag;